var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.0522,
    r: 16,
    fill: "#55ACE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1998 11.4728C22.6707 11.7138 22.101 11.8767 21.5035 11.9495C22.1137 11.5751 22.5819 10.9814 22.8025 10.2741C22.2312 10.6208 21.5998 10.873 20.9253 11.0083C20.3878 10.4197 19.6195 10.0522 18.7692 10.0522C17.1387 10.0522 15.816 11.4087 15.816 13.0815C15.816 13.319 15.8413 13.5495 15.892 13.7714C13.4367 13.6449 11.2602 12.4401 9.80223 10.6052C9.54782 11.0542 9.40244 11.5751 9.40244 12.1298C9.40244 13.1803 9.92395 14.1077 10.7168 14.6512C10.2333 14.6364 9.77688 14.4986 9.37793 14.2733V14.3105C9.37793 15.7788 10.3964 17.0035 11.7488 17.2808C11.5011 17.3519 11.24 17.3875 10.9703 17.3875C10.7802 17.3875 10.5942 17.3693 10.4142 17.3337C10.7903 18.5368 11.8806 19.413 13.1738 19.4364C12.1629 20.2494 10.8883 20.7339 9.50471 20.7339C9.26636 20.7339 9.03055 20.7201 8.7998 20.6923C10.1074 21.5504 11.6609 22.0522 13.3285 22.0522C18.7632 22.0522 21.7342 17.4369 21.7342 13.4334C21.7342 13.3016 21.7317 13.1699 21.7266 13.0408C22.3039 12.6135 22.8051 12.0804 23.1998 11.4728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 12,
    fill: "white",
    transform: "translate(8.7998 10.0522)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTw);
export default __webpack_public_path__ + "static/media/social-tw.c4c2080f475535d61ba1e95968b51715.svg";
export { ForwardRef as ReactComponent };